<template>

  <div class="worder-summary-top">
    <div class="worder-summary-top-left">
      <div class="worder-summary-top-left-item">
        <span class="label">手机号</span>
        <span class="val">{{model.phone}}</span>
      </div>
      <div class="worder-summary-top-left-item">
        <span class="label">号码状态</span>
        <span class="val">{{model.phrases || '-'}}</span>
      </div>
    </div>


  </div>
</template>

<script>

  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import { httpAction, getAction } from '@/api/manage'
  export default {
    name: 'CallTop',
    mixins: [mixin, mixinDevice],
    props: {
      disabled:{
        type:Boolean,
        default:true
      },
      model:{
        type:Object,
        default:{}
      }
    },watch:{
       callStatus:function(newVal,oldVal){
         console.log(oldVal,newVal)
         if(newVal==2){
           this.getPhoneStatus();
           this.$store.dispatch('ToggleCallStatus', 0)
         }

       }
    },methods:{
      getPhoneStatus(){
        getAction("/dm/dmPhone/getByPhone",{phone:this.model.phone}).then(res=>{
          if(res.success){
            this.$emit("updatePhoneStatus",res.result);
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>


  .worder-summary-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right:24px;
    height: 100px;
    background: #fff;
    border-radius:12px;
  }
  .worder-summary-top .worder-summary-top-left{
    flex: 1;
    display:flex;
    align-items: center;
  }
  .worder-summary-top .worder-summary-top-left .worder-summary-top-left-item{
    flex:1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
  .worder-summary-top-left-item .label{
    color: rgba(145, 146, 158, 1);
    font-size: 16px;
  }
  .worder-summary-top-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
  }
  .worder-summary-top-left-item img{
    width: 16px;
    height: 16px;
    margin-left: 30px;
  }
  .worder-summary-top-left-item .time{
    font-size: 12px;
    font-weight: 400;
    color: rgba(63, 140, 255, 1);
  }
  .worder-summary-top-btn{
    width: 145px;
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: rgba(63, 140, 255, 1);
  }
  .worder-summary-top-btn img{
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  /deep/ .worder-summary-top-btn .ant-select-selection--single{
    border: none !important;
    background: #fff !important;
    color: #3F8CFF;
  }
  /deep/ .worder-summary-top-btn .ant-select-arrow{
    color: #3F8CFF;
  }
  /deep/ .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
    -webkit-box-shadow:unset !important;
    box-shadow:unset !important;
  }
</style>